
import React, { useRef, useEffect } from 'react'

import Styles from "./modal.module.css"

const Modal = ({ children, stateName }) => {

    const back_layout = useRef(null)
    const body_layout = useRef(null)


    useEffect(() => {
        console.log("modal");
        var body = document.querySelector("body")
        // var video=document.querySelector(".modal video")
        body.style.overflow = "hidden"
        setTimeout(() => {
            back_layout.current.style.backgroundColor = "rgba(0, 0, 0, .5)"
            // video.style.opacity = "1"
        })
        back_layout.current.addEventListener("click", (e) => {
            if (e.target.classList.contains(Styles.overlay) || e.target.classList.contains("fa-plus")) {
                back_layout.current.style.backgroundColor = "rgba(0, 0, 0, 0)"
                // video.style.opacity ="0"
                setTimeout(() => {
                    stateName(false)
                    body.style.overflow = "auto"
                }, 300)
            }
        })
        return () => {
        }
    }, [])

    return (
        <div className={Styles.overlay} ref={back_layout}>
            <div className={Styles.close_icon}><i className="fas fa-plus"></i></div>
            {/* <section className={Styles.overlay_body} ref={body_layout}> */}
                
                {children}
            {/* </section> */}
        </div>
    );
}

export default Modal;